import {coachingApi, dashboardApi} from 'sources/api';
import Team from 'records/Team';
import UserActivityRanks from 'records/UserActivityRanks';
import {List} from 'immutable';
import {CoachingPlanVelocity} from 'records/CoachingPlanVelocity';
import {PlanId} from 'records/CoachingPlan';

const DATE_FORMAT = 'YYYY-MM-DD';

const DirectReportsSource = {
  directReports(managerId) {
    return coachingApi.getJson(`/teams/direct_reports?manager_id=${managerId}`).then(teams =>
      List(
        // most of team properties are nested in the `team` property,
        // some are at the top level. Flatten that out:
        teams.map(team => {
          const managerId = team.manager && team.manager.userId;
          return new Team({managerId, ...team, ...team.team});
        })
      )
    );
  },
  getSkillBreakdown(userIds) {
    return coachingApi.postJson(`/users/skill_breakdown`, userIds);
  },
  getActivityRankings(teamIds, startDate, endDate) {
    return dashboardApi
      .getJson(`/user_activity_rank`, {
        params: {
          teams: teamIds.toJS(),
          start_date: startDate.format(DATE_FORMAT),
          end_date: endDate.format(DATE_FORMAT),
        },
      })
      .then(responses => responses.map(activityRank => new UserActivityRanks(activityRank)));
  },
  planVelocities(planIds: List<PlanId>): Promise<List<CoachingPlanVelocity>> {
    return coachingApi
      .postJson(`/plans/fetch_velocity`, {planIds})
      .then(velocities => List(velocities.map(velocity => new CoachingPlanVelocity(velocity))));
  },
};

export default DirectReportsSource;
